<template>
    <MobileView v-if="isMobile && !continueOnMobile" />

    <router-view v-else-if="!isLoading" />
    <notifications :position="isRtl ? 'top left' : 'top right'" dangerously-set-inner-html />
    <CookieModal />

    <!-- Walkthrough tours -->
    <WalkthroughGeneric />

    <div v-if="isLoading" class="loading-overlay bg-light">
        <LoadingIndicator />
    </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { isRtl } from './i18n';
import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';
import { useSessionStorage } from '@vueuse/core';
import { useRoute } from 'vue-router';
import { isNonNullable } from './utils/nullability-helpers';
import { useEventsStore } from '@/stores/events.store';
import { provideWalkthrough } from '@/composables/useWalkthrough';

const { isFetchingUser, currentOrganization } = useAuthStore();

const hasFetchedOrganization = computed(() => isNonNullable(currentOrganization.value));

const { width, height } = useWindowSize();

const route = useRoute();

useEventsStore();

provideWalkthrough();

const isLoading = computed(
    () => isFetchingUser.value || (route.meta.requireOrganizationSelection && !hasFetchedOrganization.value),
);

// The widest viewport I could find is the iPhone 15 Pro Max with 430px.
const isMobile = computed(() => width.value < 435 || height.value < 435);
const continueOnMobile = useSessionStorage('continueOnMobile', false);
</script>

<style scoped lang="scss">
.loading-overlay {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1054;
    opacity: 0.85;
}
</style>
